import { Icon_Info } from "../../../BP2Components/Icons/icons";
import "./FieldInfo.less";

const FieldInfo = ({ text }) => {
   return text ? (
      <div className="field-alert-container">
         <Icon_Info />
         <span className="field-alert-container__text">{text}</span>
      </div>
   ) : null;
};

export default FieldInfo;
